// ForbiddenPage.js
import React from "react";

function ForbiddenPage() {
	return (
		<div style={styles.container}>
			<h1 style={styles.header}>403 - Forbidden</h1>
			<p style={styles.message}>
				Sorry, you don't have access to this page.
			</p>
		</div>
	);
}

const styles = {
	container: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		height: "100vh",
		backgroundColor: "#f7f7f7",
	},
	header: {
		fontSize: "3rem",
		color: "#ff5252",
		marginBottom: "20px",
	},
	message: {
		fontSize: "1.5rem",
		color: "#555",
		textAlign: "center",
	},
};

export default ForbiddenPage;
